import APIClient from '@/shared/http/clients/api'

const resourceName = 'seguro'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)

/**
 * @name InsuranceWalletRepository
 * @description Carteira Seguro
 * @type { Respository }
 */
const InsuranceWalletRepository = {
  Search
}

export default InsuranceWalletRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/insurancewallet.js